import * as z from "zod";

export const runBulkSupportV2Trueup = {
  name: "runBulkSupportV2Trueup" as const,
  input: z.object({
    teamIds: z.array(z.string()),
    dryRun: z.boolean(),
    matchVoice: z.boolean().optional(),
    noMigrateMissing: z.boolean().optional(),
    limit: z.number().int().positive().optional(),
    batchSize: z.number().optional(),
    staggerMinutes: z.number().optional(),
  }),
  output: z.object({
    workflowId: z.string(),
    accepted: z.array(z.string()),
    rejected: z.array(z.string()),
  }),
};
